import React, { Component } from "react";
import axios from "axios";
import LoadingScreen from "../../components/LoadingScreen";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import SweetAlert from "react-bootstrap-sweetalert";
import Container from "../../components/Container";
import HeadingBrief from "../../components/HeadingBrief";

class CreateBrief extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: [],
      token: localStorage.getItem("Authorization"),
      questall: [],
      answer: [],
      btypeInfo: null,
      id: "",
      bslug: this.props.match.params.btype,
      totalbrief: 0,
      isReady: 0,
      disabled: false,
      errors: [],
      alert: null,
    };
    this.checkAnswer = this.checkAnswer.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleImageChange = this.handleImageChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    axios
      .get(`${window.localhost}/customer/whois`, {
        headers: {
          Authorization: `Bearer ${this.state.token}`,
        },
      })
      .then((response) => {
        var msg = response.data.success;
        if (msg === true) {
          let progres = this.state.isReady + 10;
          this.setState({
            user: response.data.user,
            isReady: progres,
          });
          this.getQuestion();
          // console.log(response.data.user);
        } else {
          this.props.history.push("/login");
        }
      });
  }

  getQuestion() {
    axios
      .get(
        `${window.localhost}/customer/question/${this.props.match.params.btype}`,
        {
          headers: {
            Authorization: `Bearer ${this.state.token}`,
          },
        }
      )
      .then((res) => {
        let msg2 = res.data.success;
        if (msg2 === true) {
          let progres = this.state.isReady + 10;
          this.setState({
            questall: res.data.quest,
            isReady: progres,
          });
          this.getBriefInfo();
          // console.log(res.data.quest);
        }
      });
  }

  getBriefInfo() {
    axios
      .get(`${window.localhost}/admincre/getbstatus/${this.state.bslug}`)
      .then((res) => {
        if (res.data.success == true) {
          let progres = this.state.isReady + 10;
          this.setState({
            isReady: progres,
            btypeInfo: res.data.btype,
          });
          this.countBrief();
        }
      });
  }

  countBrief() {
    axios
      .get(`${window.localhost}/customer/countbrief/${this.state.bslug}`, {
        headers: {
          Authorization: `Bearer ${this.state.token}`,
        },
      })
      .then((response) => {
        let progres = this.state.isReady + 70;
        this.setState({ isReady: progres });
        if (response.data.success === true) {
          this.setState({
            totalbrief: response.data.total + 1,
            isReady: progres,
          });
        }
      });
  }

  checkAnswer() {
    const { answer } = this.state;

    const notNullable = answer.filter(
      (obj) => !Object.values(obj).includes(null)
    );
    const dataLength = notNullable.length;
    console.log(notNullable);
    console.log(dataLength);
  }

  handleFieldChange(event, qid, reqstat) {
    let theField = this.state.answer;

    let newField = {
      question_id: qid,
      answer: event.target.value,
      required: reqstat,
      type: 0,
    };

    // Extract number from name string
    let str = event.target.name;
    let numindex = str.match(/(\d+)/);

    theField[parseInt(numindex)] = newField;

    this.setState({
      answer: theField,
    });
  }

  handleImageChange(event, qid, reqstat) {
    let theField = this.state.answer;

    if (event.target.files && event.target.files[0]) {
      console.log(event.target.files[0]);
      let newField = {
        question_id: qid,
        answer: event.target.files[0],
        required: reqstat,
        type: 1,
      };

      // Extract number from name string
      let str = event.target.name;
      let numindex = str.match(/(\d+)/);

      theField[parseInt(numindex)] = newField;

      this.setState({
        answer: theField,
      });
    }
  }

  handleCheckboxChange(event, qid, ansid) {
    let theField = this.state.answer;

    // Extract number from id string
    let str = event.target.name;
    let numindex = str.match(/(\d+)/);

    let newField = {
      question_id: qid,
      answer: event.target.value,
      type: 0,
      ans_ref: ansid,
    };

    if (event.target.checked) {
      theField[parseInt(numindex)] = newField;
    } else {
      delete theField[parseInt(numindex)];
    }

    this.setState({
      answer: theField,
    });
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({
      disabled: true,
      errors: [],
    });

    let dataCounter = 0;
    let geterr = 0;
    const { answer } = this.state;

    // Membersihkan Array yang terdapat Null Value
    const cleanAnswer = answer.filter(
      (obj) => !Object.values(obj).includes(null)
    );
    const dataLength = cleanAnswer.length;

    cleanAnswer.map((ans) => {
      const formData = new FormData();
      formData.append("customer_id", this.state.user.id);
      formData.append("brief_id", this.state.totalbrief);
      formData.append("question_id", ans.question_id);

      if (ans.type === 1) {
        formData.append("answer", ans.answer, ans.answer.name);
      } else {
        formData.append("answer", ans.answer);
      }

      if (ans.ans_ref && ans.ans_ref !== null) {
        formData.append("ans_ref", ans.ans_ref);
      }

      axios
        .post(`${window.localhost}/customer/brief/create`, formData, {
          headers: {
            Authorization: `Bearer ${this.state.token}`,
          },
        })
        .then((response) => {
          let msg = response.data.success;
          if (msg === true) {
            dataCounter++;

            if (dataCounter === dataLength) {
              this.showAlert("Brief berhasil dibuat!");
            }
          }
        })
        .catch(() => {
          geterr += 1;
        });
    });
  }

  showAlert(message) {
    const getAlert = () => (
      <SweetAlert
        success
        title="Success!"
        onConfirm={() => this.goToHome()}
        onCancel={this.hideAlert()}
        timeout={2000}
        confirmBtnText="Oke Siap"
        confirmBtnBsStyle="warning"
      >
        {message}
      </SweetAlert>
    );
    this.setState({
      alert: getAlert(),
    });
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }

  goToHome() {
    this.props.history.push(`/`);
  }

  render() {
    if (this.state.isReady !== 100) {
      return <LoadingScreen />;
    } else {
      const { questall } = this.state;
      let countans = 0;
      return (
        <div>
          <Header destination={`/`} />
          <Container>
            <HeadingBrief title={this.state.btypeInfo.label} />
            <div className="row mt-3">
              <form onSubmit={this.handleSubmit}>
                {questall.map((quest, i) => (
                  <div key={i} className="mb-3">
                    <label className="form-label fw-bold">
                      {quest.label}
                      <span className="text-danger">
                        {quest.required == "1" ? "*" : ""}
                      </span>
                    </label>
                    {quest.answer_type === "input" ? (
                      <input
                        name={`input${countans++}`}
                        type="text"
                        id={`ans${countans}`}
                        aria-describedby={`quest${i}`}
                        className={`form-control form-cream border-0`}
                        onChange={(e) => this.handleFieldChange(e, quest.id)}
                        autoComplete="off"
                        disabled={this.state.disabled}
                        required={quest.required === 1 ? true : false}
                      />
                    ) : (
                      " "
                    )}

                    {quest.answer_type === "color" ? (
                      <input
                        name={`input${countans++}`}
                        type="color"
                        id={`ans${countans}`}
                        aria-describedby={`quest${i}`}
                        className={`form-control form-cream border-0`}
                        onChange={(e) => this.handleFieldChange(e, quest.id)}
                        autoComplete="off"
                        disabled={this.state.disabled}
                        required={quest.required === 1 ? true : false}
                        style={{ width: "100px" }}
                      />
                    ) : (
                      " "
                    )}

                    {quest.answer_type === "image" ? (
                      <input
                        name={`image${countans++}`}
                        type="file"
                        accept="image/png, image/jpeg, image/webp"
                        id={`ans${countans}`}
                        aria-describedby={`quest${i}`}
                        className={`form-control form-cream`}
                        onChange={(e) => this.handleImageChange(e, quest.id)}
                        disabled={this.state.disabled}
                        required={quest.required === 1 ? true : false}
                      />
                    ) : (
                      " "
                    )}
                    {quest.answer_type === "textarea" ? (
                      <textarea
                        name={`textarea${countans++}`}
                        type="text"
                        id={`ans${countans}`}
                        aria-describedby={`quest${i}`}
                        className={`form-control form-cream border-0`}
                        onChange={(e) => this.handleFieldChange(e, quest.id)}
                        disabled={this.state.disabled}
                        required={quest.required === 1 ? true : false}
                      />
                    ) : (
                      " "
                    )}
                    {quest.answer_type === "select" ? (
                      <select
                        name={`select${countans++}`}
                        id={`ans${countans}`}
                        className="form-select form-cream border-0"
                        aria-label="Default select example"
                        onChange={(e) => this.handleFieldChange(e, quest.id)}
                        disabled={this.state.disabled}
                        required={quest.required === 1 ? true : false}
                      >
                        <option defaultValue>--- Pilih industri ---</option>
                        {quest.answer.map((ans, ans_i) => (
                          <option key={ans_i} value={ans.answer_label}>
                            {ans.answer_label}
                          </option>
                        ))}
                      </select>
                    ) : (
                      " "
                    )}

                    {quest.answer_type === "radios0" ? (
                      <div
                        className={`row ${
                          quest.answer.length > 6
                            ? "row-cols-sm-4 row-cols-2"
                            : "row-cols-sm-3 row-cols-1"
                        } g-4`}
                        id={quest.id}
                      >
                        {quest.answer.map((ans, ans_i) => (
                          <div key={ans_i} className="col">
                            <input
                              className="form-check-input"
                              type="radio"
                              name={`radios${
                                quest.answer.length === ans_i + 1
                                  ? countans++
                                  : countans
                              }`}
                              id={`ans${quest.id}${ans_i}`}
                              autoComplete="off"
                              value={ans.answer_label}
                              onChange={(e) =>
                                this.handleFieldChange(e, quest.id)
                              }
                              disabled={this.state.disabled}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`ans${quest.id}${ans_i}`}
                            >
                              <span className="ms-2">{ans.answer_label}</span>
                            </label>
                          </div>
                        ))}
                      </div>
                    ) : (
                      ""
                    )}

                    {quest.answer_type === "radios1" ? (
                      <div
                        className={`row ${
                          quest.answer.length > 6
                            ? "row-cols-sm-4 row-cols-2"
                            : "row-cols-sm-3 row-cols-1"
                        } g-4`}
                        id={quest.id}
                      >
                        {quest.answer.map((ans, ans_i) => (
                          <div key={ans_i} className="col">
                            <input
                              type="radio"
                              className="btn-check"
                              name={`radios${
                                quest.answer.length === ans_i + 1
                                  ? countans++
                                  : countans
                              }`}
                              id={`ans${quest.id}${ans_i}`}
                              autoComplete="off"
                              value={ans.answer_label}
                              onChange={(e) =>
                                this.handleFieldChange(e, quest.id)
                              }
                              disabled={this.state.disabled}
                            />
                            <label
                              className="btn btn-cream w-100 h-100 px-3 py-3"
                              htmlFor={`ans${quest.id}${ans_i}`}
                            >
                              {ans.answer_label ? (
                                <h6>{ans.answer_label}</h6>
                              ) : (
                                ""
                              )}
                              {ans.answer_desc ? (
                                <p className="fs-7">{ans.answer_desc}</p>
                              ) : (
                                ""
                              )}
                              {ans.answer_img ? (
                                <img
                                  className="img-fluid"
                                  src={`${window.localhost}/brief/admin/${ans.answer_img}`}
                                  alt={ans.answer_label}
                                />
                              ) : (
                                ""
                              )}
                            </label>
                          </div>
                        ))}
                      </div>
                    ) : (
                      " "
                    )}

                    {quest.answer_type === "radios2" ? (
                      <div
                        className={`row ${
                          quest.answer.length > 6
                            ? "row-cols-sm-4 row-cols-2"
                            : "row-cols-sm-3 row-cols-1"
                        } g-4`}
                        id={quest.id}
                      >
                        {quest.answer.map((ans, ans_i) => (
                          <div key={ans_i} className="col">
                            <input
                              type="radio"
                              className="btn-check"
                              name={`radios${
                                quest.answer.length === ans_i + 1
                                  ? countans++
                                  : countans
                              }`}
                              id={`ans${quest.id}${ans_i}`}
                              autoComplete="off"
                              value={ans.answer_label}
                              onChange={(e) =>
                                this.handleFieldChange(e, quest.id)
                              }
                              disabled={this.state.disabled}
                              required={ans.required === 1 ? true : false}
                            />
                            <label
                              className="btn btn-outline-warning text-dark w-100 h-100 px-3 py-3"
                              htmlFor={`ans${quest.id}${ans_i}`}
                            >
                              {ans.answer_label ? (
                                <h6>{ans.answer_label}</h6>
                              ) : (
                                ""
                              )}
                              {ans.answer_desc ? (
                                <p className="fs-7">{ans.answer_desc}</p>
                              ) : (
                                ""
                              )}
                              {ans.answer_img ? (
                                <img
                                  className="img-fluid mt-2"
                                  src={`${window.localhost}/brief/admin/${ans.answer_img}`}
                                  alt={ans.answer_label}
                                />
                              ) : (
                                ""
                              )}
                            </label>
                          </div>
                        ))}
                      </div>
                    ) : (
                      " "
                    )}

                    {quest.answer_type === "checkbox1" ? (
                      <div
                        className={`row ${
                          quest.answer.length > 6
                            ? "row-cols-sm-4 row-cols-2"
                            : "row-cols-sm-3 row-cols-1"
                        } g-4`}
                        id={quest.id}
                      >
                        {quest.answer.map((ans, ans_i) => (
                          <div key={ans_i} className="col">
                            <input
                              type="checkbox"
                              className="btn-check"
                              name={`radios${countans++}`}
                              id={`ans${quest.id}${ans_i}`}
                              autoComplete="off"
                              value={ans.answer_label}
                              onChange={(e) =>
                                this.handleCheckboxChange(e, quest.id, ans.id)
                              }
                              disabled={this.state.disabled}
                            />
                            <label
                              className="btn btn-cream w-100 h-100 px-3 py-3"
                              htmlFor={`ans${quest.id}${ans_i}`}
                            >
                              {ans.answer_label ? (
                                <h6>{ans.answer_label}</h6>
                              ) : (
                                ""
                              )}
                              {ans.answer_desc ? (
                                <p className="fs-7">{ans.answer_desc}</p>
                              ) : (
                                ""
                              )}
                              {ans.answer_img ? (
                                <img
                                  className="img-fluid"
                                  src={`${window.localhost}/brief/admin/${ans.answer_img}`}
                                  alt={ans.answer_label}
                                />
                              ) : (
                                ""
                              )}
                            </label>
                          </div>
                        ))}
                      </div>
                    ) : (
                      " "
                    )}

                    {quest.answer_type === "checkbox2" ? (
                      <div
                        className={`row ${
                          quest.answer.length > 6
                            ? "row-cols-sm-4 row-cols-2"
                            : "row-cols-sm-3 row-cols-1"
                        } g-4`}
                        id={quest.id}
                      >
                        {quest.answer.map((ans, ans_i) => (
                          <div key={ans_i} className="col">
                            <input
                              type="checkbox"
                              className="btn-check"
                              name={`radios${countans++}`}
                              id={`ans${quest.id}${ans_i}`}
                              autoComplete="off"
                              value={ans.answer_label}
                              onChange={(e) =>
                                this.handleCheckboxChange(e, quest.id, ans.id)
                              }
                              disabled={this.state.disabled}
                            />
                            <label
                              className="btn btn-cf-yellow text-dark w-100 h-100 px-3 py-3"
                              htmlFor={`ans${quest.id}${ans_i}`}
                            >
                              {ans.answer_label ? (
                                <h6>{ans.answer_label}</h6>
                              ) : (
                                ""
                              )}
                              {ans.answer_desc ? (
                                <p className="fs-7">{ans.answer_desc}</p>
                              ) : (
                                ""
                              )}
                              {ans.answer_img ? (
                                <img
                                  className="img-fluid"
                                  src={`${window.localhost}/brief/admin/${ans.answer_img}`}
                                  alt={ans.answer_label}
                                />
                              ) : (
                                ""
                              )}
                            </label>
                          </div>
                        ))}
                      </div>
                    ) : (
                      " "
                    )}
                  </div>
                ))}

                <button
                  type="submit"
                  className="btn btn-red text-light fs-5 px-4 float-end"
                >
                  <span
                    className={`spinner-border spinner-border-sm ${
                      this.state.disabled ? " " : "d-none"
                    }`}
                    role="status"
                    aria-hidden="true"
                  ></span>{" "}
                  Kirim Brief
                </button>
              </form>
              {/* <button
                type="button"
                className="btn btn-red text-light fs-5 px-4 float-end"
                onClick={this.checkAnswer}
              >
                Check Answer
              </button> */}
            </div>
          </Container>
          {this.state.alert}
          <Footer />
        </div>
      );
    }
  }
}

export default CreateBrief;
